import apiClient from "./apiClient";

const buildPaginatedResult = (responseData, fallbackPage, fallbackPageSize) => {
  const rows = responseData?.data || responseData?.logs || responseData?.items || [];
  const meta = responseData?.pagination || responseData?.meta || responseData || {};
  const currentPage = Number(
    meta.current_page ?? meta.page ?? responseData?.page ?? fallbackPage
  );
  const pageSize = Number(
    meta.per_page ?? meta.page_size ?? meta.pageSize ?? fallbackPageSize
  );
  const totalItemsValue =
    meta.total ??
    meta.total_count ??
    meta.total_items ??
    responseData?.total ??
    null;
  const totalItems =
    totalItemsValue === null || totalItemsValue === undefined
      ? null
      : Number(totalItemsValue);
  const totalPagesValue =
    meta.last_page ?? meta.total_pages ?? responseData?.last_page ?? null;
  const totalPages =
    totalPagesValue === null || totalPagesValue === undefined
      ? totalItems !== null && pageSize > 0
        ? Math.max(1, Math.ceil(totalItems / pageSize))
        : null
      : Number(totalPagesValue);
  const hasNext =
    totalPages !== null
      ? currentPage < totalPages
      : Array.isArray(rows) && rows.length === pageSize;

  return {
    pagination: {
      currentPage,
      hasNext,
      pageSize,
      totalItems,
      totalPages,
    },
    rows: Array.isArray(rows) ? rows : [],
  };
};

const getLogs = async (path, params = {}) => {
  const fallbackPage = Number(params.page || 1);
  const fallbackPageSize = Number(params.page_size || 10);
  const response = await apiClient.get(path, { params });
  return buildPaginatedResult(response.data, fallbackPage, fallbackPageSize);
};

export const getActivityLogs = (params = {}) =>
  getLogs("/api/logs/activity", params);

export const getAuditLogs = (params = {}) =>
  getLogs("/api/logs/audit", params);

export const getSecurityLogs = (params = {}) =>
  getLogs("/api/logs/security", params);
